
window.addEventListener('load', function() {
    var lochref = window.location.href;
    console.log(lochref);
    if (lochref.indexOf('#') > -1) {
        var anchor = lochref.slice(lochref.indexOf('#'));
        var element = document.querySelector(anchor);
        if (element) {
            window.setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop,
                    behavior: 'smooth'
                });
            }, 1);
        }
    }
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});